/* @flow */
import { FETCH } from './action-types.js';

/**
 * Fetch all sectors
 */
export const fetch = () => ({
  type: FETCH,
});



// WEBPACK FOOTER //
// ./src/app/modules/sectors/actions.js